import { Button } from './Button';

interface PagerProps {
  page: number;
  perPage: number;
  total: number;
  onChange: (page: number) => void;
}

export function Pager({ page, perPage, total, onChange }: PagerProps) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <div className="flex items-center justify-center gap-2 mt-3 text-sm">
      <Button variant="secondary" disabled={!canPrev} onClick={() => onChange(page - 1)}>
        ← 前
      </Button>
      <span className="text-muted">
        {page} / {totalPages} ページ（全 {total} 件）
      </span>
      <Button variant="secondary" disabled={!canNext} onClick={() => onChange(page + 1)}>
        次 →
      </Button>
    </div>
  );
}
